import { Box, Card, CardContent, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, InputAdornment, Grid } from '@mui/material';
import { Search, Download, Print } from '@mui/icons-material';
import { libroDiario } from '../billingData';

const DiaryBook = () => {
  const totalDebe = libroDiario.reduce((acc, doc) => acc + doc.debe, 0);
  const totalHaber = libroDiario.reduce((acc, doc) => acc + doc.haber, 0);

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom>
            Libro Diario
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Registro cronológico de todas las transacciones comerciales
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" startIcon={<Print />}>
            Imprimir
          </Button>
          <Button variant="contained" startIcon={<Download />} color="primary">
            Exportar Excel
          </Button>
        </Box>
      </Box>

      {/* Stats */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6}>
          <Card sx={{ backgroundColor: '#e3f2fd' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Total Débito</Typography>
              <Typography variant="h4" color="primary">${totalDebe.toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card sx={{ backgroundColor: '#e8f5e9' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Total Crédito</Typography>
              <Typography variant="h4" color="success.main">${totalHaber.toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Filters */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar concepto..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Desde"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Hasta"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Button variant="outlined" fullWidth>
                Generar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Table */}
      <Card>
        <CardContent>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell sx={{ fontWeight: 'bold' }}>Fecha</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Concepto</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Cuenta</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Debe</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Haber</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {libroDiario.map((doc, index) => (
                  <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#fafafa' } }}>
                    <TableCell>{doc.fecha}</TableCell>
                    <TableCell>{doc.concepto}</TableCell>
                    <TableCell>{doc.cuenta}</TableCell>
                    <TableCell align="right" sx={{ fontWeight: doc.debe > 0 ? 500 : 0 }}>
                      {doc.debe > 0 ? `$${doc.debe.toFixed(2)}` : '-'}
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: doc.haber > 0 ? 500 : 0 }}>
                      {doc.haber > 0 ? `$${doc.haber.toFixed(2)}` : '-'}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow sx={{ backgroundColor: '#e3f2fd', fontWeight: 'bold' }}>
                  <TableCell colSpan={3} sx={{ fontWeight: 'bold' }}>TOTALES</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>${totalDebe.toFixed(2)}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>${totalHaber.toFixed(2)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Info */}
      <Card sx={{ mt: 3, backgroundColor: '#f5f5f5' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Libro Diario
          </Typography>
          <Typography variant="body2">
            El libro diario es un documento contable obligatorio que registra cronológicamente todas las operaciones 
            comerciales de la empresa. Cada transacción se registra con cargo (debe) y abono (haber).
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DiaryBook;
